/*
    2020-04-26
    曹秀芳
    制作DeviceServiceDownload页面
*/ 
<template>
  <div class="DeviceServiceDownload mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/DeviceServiceDownload"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
        <el-main>
          <div class="mainWrao">
            <div class="recordTitle">
              <h1>设备服务-资料下载</h1>
            </div>
            <div class="my">
                <div v-for="item in fileList" :key="item.key" class="list-item">
                      <div>
                          <div class="item-title">{{item.copykey}}</div>
                          <div class="item-record">
                              <div>上传：<span>{{item.lastModified}}</span></div>
                              <div style="margin-left:30px;">已下载：<span>{{item.downloadCount}}</span>次</div>
                          </div>
                      </div>
                      <div class="item-down-word">
                          <el-button @click="exportExcel(item.key,item.lastModified)" type="primary" size="mini"><i class="el-icon-download"></i> 下载</el-button>
                      </div>
                </div>
            </div>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"

export default {
  name: 'DeviceServiceDownload',
  components: {
    leftNav
  },
  data () {
    return {
        fileList:[]
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
  },
  mounted() {
      this.getList()
  },
  methods: {
    getList(){
        let _this = this
        this.axios({
            method: 'post',
            url: '/url/file/list',
            params:{
                language: _this.$store.state.lang,
            }
        }).then(function(res){
            if (res.data.success === 'true') {
                res.data.data.forEach(item=>{
                    // 获取 已下载次数
                    if(item.downloadCount == null){
                        item.downloadCount = 0
                    }
                    // 获取 上传时间
                    let dateTimeObj = new Date(item.lastModified)
                    var year=dateTimeObj.getFullYear();  //取得4位数的年份
                    var month=dateTimeObj.getMonth()+1;  //取得日期中的月份，其中0表示1月，11表示12月
                        if(month<10){
                            month = '0'+month
                        }
                    var date=dateTimeObj.getDate();      //返回日期月份中的天数（1到31）
                        if(date<10){
                            date = '0'+date
                        }
                    var hour=dateTimeObj.getHours();     //返回日期中的小时数（0到23）
                        if(hour<10){
                            hour = '0'+hour
                        }
                    var minute=dateTimeObj.getMinutes(); //返回日期中的分钟数（0到59）
                        if(minute<10){
                            minute = '0'+minute
                        }
                    var second=dateTimeObj.getSeconds(); //返回日期中的秒数（0到59）
                        if(second<10){
                            second = '0'+second
                        }
                    let dateTime= year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
                    item.lastModified = dateTime
                    // 截取文件命
                    let index = item.key.lastIndexOf("/")
                    item.copykey =item.key .substring(index+1,item.key.length);
                })
                _this.fileList = res.data.data
            } 
            // else {
            //     _this.$message.error('Machine list loading failed')
            // }
        })
    },

    // 下载
    exportExcel(key){
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        let urlData = '?language='+ this.$store.state.lang +'&key='+ key+'&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime+'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
        window.open('/url/file/download' + urlData, '_blank')
    }
  }
}
</script>


<style scoped>
.DeviceServiceDownload{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
}
/* 我的样式 */
.my{
    padding: 10px;
}
.list-item{
    display:flex;
    justify-content: space-between;
    padding: 10px;
    background-color: #fff;
    border-radius: 3px;
	box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
}
.item-title{
    font-size: 16px;
	line-height: 200%;
	font-weight: bold;
    margin-bottom: 10px;
}
.item-record{
    display:flex;
    color: rgba(157, 157, 157, 1);
	font-size: 14px;
	line-height: 150%;
    font-weight: bold;
}
.item-down-word{
    padding-top: 16px;
}
/* element-ui样式 */
</style>

